import { OFFER_HUB_LINKED, OFFER_MODAL_VIEW } from '../actions/types';

export const triggerOfferModalIsViewed = data => ({
  type: OFFER_MODAL_VIEW,
  data,
});

export const triggerOfferIsLinked = data => ({
  type: OFFER_HUB_LINKED,
  data,
});
